import axios from "axios";

export async function getPricingData() {
  const response = await axios.get(
    "https://api.transpond.io/api/pricing/tiers?advanced=true"
  );

  return response.data;
}
